import { CheckUserFormValues } from "./types";

export const initialValues: CheckUserFormValues = {
  email: "",
};
